import AudioUpload from '@/pages/Lessons/ContentGenerator/Audio/AudioUpload/AudioUpload';

const AudioPage = () => {
  const handleAudioUpload = () => {
    // Ici vous pourriez envoyer le fichier au serveur
  };

  return (
    <>
      <div>
        <AudioUpload onAudioUpload={handleAudioUpload} />
      </div>
    </>
  );
};

export default AudioPage;
